module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_community-3ce05521ecad561159af6d64fd2ad025.png";